import React from 'react'
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({payProCount , dealerCount}) => {
  const chartData = {
    labels: ["Pay Pro", "Dealership"], // Labels for each segment
    datasets: [
      {
        label: "Views", // Pie chart label
        data: [payProCount, dealerCount], // Data points for the pie chart
        backgroundColor: [
          "#003f5c", // Color for Website Views (light blue)
          "#ffa600", // Color for App Views (light red)
        ],
        borderColor: [
          "rgba(75, 192, 192, 1)",
          "rgba(255, 99, 132, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  // Chart Options
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top", // Position of the legend
      },
      title: {
        display: true,
        text: "Total Orders", // Chart title
      },
    },
  };
  return <Pie  height={954} width={954}  data={chartData} options={chartOptions} />

}

export default PieChart